<template>
    <div>
        <WeightValidation ref="WeightValidation"></WeightValidation>
        <GenericPopups ref="GenericPopups"></GenericPopups>
        <LoadingSpinner :busy="loading"></LoadingSpinner>
        <b-card v-if="order && !loading">
            <template v-slot:header>
                <OrderCardHeader :order="order"></OrderCardHeader>
            </template>

            <b-card no-body>
                <template v-slot:header>
                    <h5>Bag and Inventory Confirmation</h5>
                </template>
                <template v-for="(value, name, index) in _getBagsByMetal">

                    <b-card class="mb-0 border-top-0" no-body :key="index"
                            header-class="p-1 font-weight-bold metal-header"
                            :header="name | titleCase"
                            body-class="inventory-table">

                        <b-table
                            head-variant="dark"
                            thead-class="p-0"
                            thead-tr-class="p-0"
                            hover
                            small
                            borderless
                            :items="_getBagsByMetal[name]"
                            :fields="bag_inventory.fields"
                            v-if="!loading_items"
                            class="text-center"
                            tbody-tr-class="p-1 font-weight-bold font-lg" :disabled="working">


                            <!--open-bag-->
                            <template v-slot:cell(open_bag)="row">
                                <b-button variant="light" size="sm"
                                          @click="row.toggleDetails" class="cursor-pointer"
                                          :disabled="working">
                                    <i class="fa-solid text-success"
                                       :class="row.detailsShowing ? 'fa-minus-circle': 'fa-plus-circle' "></i>
                                </b-button>
                            </template>


                            <!--BAG PURITY ITEMS-->
                            <template v-slot:row-details="data">
                                <b-row>
                                    <b-col offset="1">
                                        <!--                                                    <b-card border-variant="light" body-class="p-0" class="mb-0">-->
                                        <b-table
                                            small
                                            outlined
                                            thead-class="font-weight-light font-italic text-muted"
                                            class="mb-3 font-xs"
                                            tbody-tr-class="font-weight-normal"
                                            :fields="['id', 'Label','item_details','quantity','weight']"
                                            :items="_getMeltItems[data.item.bag_id]"
                                            :disabled="working"
                                        >
                                            <!--id-->
                                            <template v-slot:cell(id)="data">
                                                <!--<b-button variant="link"-->
                                                          <!--:to="'/appraisals/appraise/'+$route.params.id+'/inventory/'+data.item.id + '?after_save=QA' ">-->
                                                    <!--{{ data.value }}-->
                                                <!--</b-button>-->

                                                <b-button variant="link"
                                                          :to="'/appraisals/appraise/'+$route.params.id+'/inventory/'+ data.item.id ">
                                                    {{ data.value }}
                                                </b-button>
                                            </template>

                                            <!--label-->
                                            <template v-slot:cell(label)="data">
                                                <b-button variant="light" class="cursor-pointer"
                                                          :disabled="working" size="sm"
                                                          @click="printLabel('item', data.item)">
                                                    <i class="fa-regular fa-print"></i>
                                                </b-button>
                                            </template>

                                            <!--details-->
                                            <template v-slot:cell(item_details)="data">
                                                {{ data.item.type_name }}
                                            </template>

                                            <!--weight-->
                                            <template v-slot:cell(weight)="data">
                                                {{ data.item.aggregate_dwt }} dwt
                                            </template>
                                        </b-table>
                                        <!--                                                    </b-card>-->
                                    </b-col>
                                </b-row>
                            </template>


                            <!--purity-->
                            <template v-slot:cell(purity)="data">
                                {{ data.item.bag_purity | ucFirst }}  {{ data.item.contains_melee ? ' Melee' : '' }}
                            </template>

                            <!--bag size-->
                            <template v-slot:cell(bag_size)="data">
                                <b-row no-gutters>
                                    <b-col cols="3"></b-col>
                                    <b-col cols="6">
                                        <b-select v-model="data.item.bag_type_id" :options="bagOptions"
                                                  :disabled="data.item.saving" class="font-weight-bold text-center"
                                                  @change="changeBagSize(data.item)">
                                        </b-select>
                                        <div class="font-xs text-muted">Bag ID: {{ data.item.bag_id }}</div>
                                    </b-col>
                                    <b-col cols="3">
                                        <div class="text-left"><i class="fa-regular fa-spinner fa-spin fa-fw"
                                                                  v-if="data.item.saving"></i></div>
                                    </b-col>
                                </b-row>
                            </template>

                            <!--expected weight-->
                            <template v-slot:cell(expected_weight)="data">
                                <div class="font-xxs text-muted">Item: ({{ data.item.item_weight }} dwt) +
                                    Bag: ({{ data.item.material_dwt }} dwt) =
                                </div>
                                {{
                                    parseFloat(data.item.item_weight) + parseFloat(data.item.material_dwt) | toFixed2
                                }} dwt
                            </template>

                            <!--label-->
                            <template v-slot:cell(label)="data">
                                <b-button variant="light" class="cursor-pointer"
                                          @click="printLabel('bag', data.item)" :disabled="working"
                                          size="sm">
                                    <i class="fa-regular fa-print"></i>
                                </b-button>
                            </template>

                        </b-table>

                    </b-card>
                </template>

                <template v-if="QA.holds.length != 0">
                    <!--HELD TABLE-->
                    <b-card class="border-top-0 mb-0"
                            header-class="p-1 font-weight-bold metal-header"
                            header="Held Items" no-body
                            v-if="!loading_items"
                            body-class="inventory-table">
                        <b-table
                                head-variant="dark"
                                ref="hold_items_table"
                                outlined
                                small
                                :items="QA.holds"
                                :fields="held_items.fields"
                                responsive="sm"
                                :busy="loading_items"
                                show-empty
                                tbody-tr-class="p-1 font-weight-bold font-lg"
                                class="text-center mb-0"
                        >
                            <template v-slot:table-busy>
                                <LoadingSpinner :busy="!QA.holds.length > 0"/>
                            </template>

                            <template v-slot:head(verified?)="data">
                                Verified?
                                <i v-if="!held_items.selectAll && _canEdit"
                                   class="cursor-pointer fa-solid fa-square ml-1"
                                   @click="setQA('all-hold', {verified: true},false, true, ()=>{held_items.selectAll = !held_items.selectAll} );">
                                </i>
                                <i v-if="held_items.selectAll && _canEdit"
                                   class="cursor-pointer fa-solid fa-check-square ml-1"
                                   @click="setQA('all-hold', {verified: false},false, true, ()=>{held_items.selectAll = !held_items.selectAll});">
                                </i>
                            </template>

                            <!--verified-->
                            <template v-slot:cell(id)="data">
                                <b-button variant="link"
                                          :to="'/appraisals/appraise/'+$route.params.id+'/inventory/'+data.item.id">
                                    {{ data.value }}
                                </b-button>
                            </template>


                            <!--verified-->
                            <template v-slot:cell(verified?)="data">
                                <b-button :variant="data.item.verified ? 'success': 'light' " class="cursor-pointer" size="sm"
                                          @click="setQA('inventory', data.item, 'verify')" :disabled="working || !_canEdit">
                                    <i class="far"
                                       :class="data.item.verified ? 'fa-check-square': 'fa-square' "></i>
                                </b-button>
                            </template>

                            <!--item type-->
                            <template v-slot:cell(class)="data">
                                {{ data.item.class | titleCase }}<span v-if="data.item.purity || data.item.purity_type"> - {{ data.item.purity }} {{ data.item.purity_type }}</span>
                            </template>

                            <!--item type-->
                            <template v-slot:cell(item_type)="data">
                                {{ data.item.type_name }}
                            </template>

                            <!--bag size-->
                            <template v-slot:cell(bag_size)="data">
                                <b-row no-gutters>
                                    <b-col cols="3"></b-col>
                                    <b-col cols="6">
                                        <b-select v-model="data.item.bag_type_id" :options="bagOptions"
                                                  :disabled="data.item.saving" class="font-weight-bold text-center"
                                                  @change="changeBagSize(data.item)">
                                        </b-select>
                                        <div class="font-xs text-muted">Bag ID: {{ data.item.bag_id }}</div>
                                    </b-col>
                                    <b-col cols="3">
                                        <div class="text-left"><i class="fa-regular fa-spinner fa-spin fa-fw"
                                                                  v-if="data.item.saving"></i></div>
                                    </b-col>
                                </b-row>
                            </template>

                            <!--expected weight-->
                            <template v-slot:cell(expected_weight)="data">
                                <div class="font-xxs text-muted">Item: ({{ data.item.item_weight }} dwt) +
                                    Bag: ({{ data.item.material_dwt }} dwt) =
                                </div>
                                {{
                                parseFloat(data.item.item_weight) + parseFloat(data.item.material_dwt) | toFixed2
                                }} dwt
                            </template>


                            <!--error-->
                            <template v-slot:cell(error)="data">
                                <b-form-checkbox class="cursor-pointer nice-toggle-error" name="check-button" switch
                                                 :checked="data.item.has_error"
                                                 @change="displayErrorField(data.item)"
                                                 :id="'error-'+data.item.id"
                                                 :disabled="working || !_canEdit"></b-form-checkbox>
                                <div v-if="data.item.has_error && seekSelectedType(data.item.error_type)" class="small">
                                    {{seekSelectedType(data.item.error_type)}}
                                </div>
                                <div v-if="data.item.has_error && data.item.description" class="small">
                                    {{data.item.description}}
                                </div>
                                <b-popover title="Describe Error" :target="'error-'+data.item.id" :show.sync="compliance_edits.currentEdit == data.item.id" placement="bottom" triggers="">
                                    <b-select :options="compliance_edits.types" v-model="compliance_edits.selected_type" placeholder="Select Error Type" @change="$forceUpdate()">

                                    </b-select>
                                    <b-select v-if="compliance_edits.subCatagory[String(compliance_edits.selected_type)] != undefined" class="mt-2"
                                              placeholder="Select Error-Subtype Type"
                                              :options="compliance_edits.subCatagory[String(compliance_edits.selected_type)]" v-model="compliance_edits.subCatagoryText">
                                    </b-select>
                                    <b-form-input v-else-if="!!(compliance_edits.selected_type)" v-model="compliance_edits.subCatagoryText" placeholder="Enter Description" class="mt-2">

                                    </b-form-input>
                                    <hr>
                                    <div class="">
                                        <b-button class="float-right mb-2" variant="success"
                                                  @click="saveErrorDescription(data.item)"
                                                  size="sm">
                                            <i class="fa-solid fa-check fa-fw"></i>
                                            Save
                                        </b-button>

                                        <b-button class="float-right mb-2 mr-1"
                                                  @click="cancelErrorField"
                                                  size="sm">
                                            <i class="fa-solid fa-check fa-times"></i>
                                            Cancel
                                        </b-button>
                                    </div>
                                </b-popover>
                            </template>

                            <!--label-->
                            <template v-slot:cell(label)="row">
                                <b-button variant="light" class="cursor-pointer" size="sm" @click="printLabel('hold', row.item)"
                                          :disabled="working">
                                    <i class="fa-regular fa-print"></i>
                                </b-button>
                            </template>

                        </b-table>
                    </b-card>
                </template>
                <div class="text-center">
                    <LoadingSpinner :busy="loading_items" v-if="loading_items"></LoadingSpinner>
                    <div class=" py-2 my-2" v-else-if="QA.bags.length == 0 && QA.holds.length == 0">
                        No inventory exists
                    </div>
                </div>
                <!--END METALS TABLE-->

                <b-card class="mb-0 border-top-0"
                        header-class="p-1 bg-secondary font-weight-bold"
                        header="Totals" no-body
                        body-class="inventory-table">

                    <b-table-simple class="text-center font-weight-bold">
                        <b-thead style="background: #333; color:white;">
                            <b-tr>
                                <b-td># of Items</b-td>
                                <b-td># of Hold Items</b-td>
                                <b-td>Weight of 0 Value</b-td>
                                <b-td>Weight of Precious Metal</b-td>
                                <b-td>Weight of PM + 0 Value</b-td>
                                <b-td>Weight of PM + 0 value + Hold</b-td>
                                <b-td>Total weight with bags</b-td>
                            </b-tr>
                        </b-thead>
                        <b-td class="font-xl">{{ _getTotalItems }}</b-td>
                        <b-td class="font-xl">{{ _getTotalHeldItems }}
                            <div class="font-xs">({{ _getWeightOfHeldItems | toFixed2 }} dwt)</div>
                        </b-td>
                        <b-td class="font-xl">{{ _getWeightOfNonPreciousMetalItems | toFixed2 }} dwt</b-td>
                        <b-td class="font-xl">{{ _getWeightOfPreciousMetalItems | toFixed2 }} dwt</b-td>
                        <b-td class="font-xl">{{ ( _getWeightOfNonPreciousMetalItems + _getWeightOfPreciousMetalItems ) | toFixed2 }}
                            dwt
                        </b-td>
                        <b-td class="font-xl">{{ _getWeightOfAllItems | toFixed2 }} dwt
                        </b-td>
                        <b-td class="font-xl">{{ _getWeightWithBags | toFixed2 }} dwt</b-td>
                    </b-table-simple>
                </b-card>
            </b-card>
        </b-card>

        <div class="text-right" v-if="!loading">
            <b-button size="lg" variant="secondary" class="ml-2" :disabled="working"
                      :to="'/appraisals/appraise/'+ $route.params.id">
                <i class="fa-solid fa-edit"></i> Cancel and Return to Inventory Appraisal
            </b-button>

            <b-button size="lg" variant="info" class="ml-2" :disabled="working || loading_items"
                      @click="printLabelsAndClose" v-if="_withinAllowedWeightVariance">
                <span v-if="working || loading_items">
                    <i class="fa-solid fa-spinner fa-spin"></i> Processing...
                </span>
                <span v-else>
                    <i class="fa-solid fa-check"></i> Close Inventory and Print Labels
                </span>
            </b-button>

            <b-button size="lg" variant="danger" class="ml-2" :disabled="working || loading_items"
                                 @click="printLabelsAndCloseOverride" v-else>
                <span v-if="working || loading_items">
                    <i class="fa-solid fa-spinner fa-spin"></i> Processing...
                </span>
                <span v-else>
                    <i class="fa-solid fa-check-double"></i> Override Close Inventory and Print Labels
                </span>
             </b-button>

            <b-form-checkbox size="lg" class="ml-2" inline v-model="print_hold_labels" name="check-button" switch
                             v-b-tooltip.hover
                             :title="print_hold_labels ? 'Yes' : 'No'">
                Print Hold Labels
            </b-form-checkbox>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import LoadingSpinner from '@/components/LoadingSpinner';
import OrderCardHeader from '@/components/OrderCardHeader';
import WeightValidation from '@/components/WeightValidation';
import GenericPopups from '../../components/GenericPopups';


export default {
    name: 'appraisals-bagging',
    components: {
        LoadingSpinner,
        OrderCardHeader,
        WeightValidation: WeightValidation,
        GenericPopups: GenericPopups,
    },
    data() {
        return {
            loading_items: false,
            loading: false,
            working: false,
            canProceed: false,
            order: null,
            intakeItemWeight: null,
            print_hold_labels: false,
            bagOptions: [
                {value: null, text: 'Please select an option', disabled: true,},
                {value: 1, text: 'Small Bag'},
                {value: 2, text: 'Medium Bag'},
                {value: 3, text: 'Large Bag'},
                {value: 4, text: 'X-Large Bag'}
            ],
            bags: null,
            QA: {
                bags: [],
                holds: [],
                inventoryByMetal: {},
            },
            bag_inventory: {
                fields: ['open_bag', 'purity', 'items', 'bag_size', 'expected_weight', 'label'],
                selected: [],
                selectAll: false,
            },
            held_items: {
                fields: ['id', 'class',  'item_type', 'bag_size', 'expected_weight', 'label'],
                selected: [],
                selectAll: false,
            },
        };
    },
    mounted() {
        this.getData();
        this.$qz.connect().then(() => {
        });
    },
    beforeDestroy() {

    },
    methods: {
        getData() {
            this.loading_items = true;
            this.loading = true;
            this.working = true;
            this.order = null;
            this.QA = {
                bags: [],
                holds: [],
                inventoryByMetal: {},
            };

            this.$http.get('/orders/' + this.$route.params.id + '/bags')
                .then((response) => {
                    let bags = response.data.data;
                    this.bags = bags;
                    this.$http.get('/qa/' + this.$route.params.id).then((response) => {
                        let QA = response.data.data;
                        bags.forEach((bag) => {
                            if (bag.inventory.length > 0) { //valid bags only (issue detected/found due to editing inventory)
                                if (bag.bag_contents_status === 'hold') {
                                    this.QA.holds.push({
                                        id: bag.held_inventory_item_id,
                                        bag_id: bag.id,
                                        children: bag.inventory[0].children,
                                        type: bag.inventory[0].type,
                                        type_name: bag.inventory[0].type_name,
                                        bag: bag,
                                        bag_purity: bag.class + ' ' + bag.purity + ' ' + bag.purity_type,
                                        bag_type_id: bag.bag_type_id,
                                        bag_type: bag.bagType.name,
                                        class: bag.class,
                                        purity: bag.purity,
                                        purity_type: bag.purity_type,
                                        material_dwt: bag.bagType.bag_dwt,
                                        //items: bag.inventory.length,
                                        dwt: bag.inventory[0].aggregate_dwt,
                                        item_weight: bag.dwt,
                                        aggregate_dwt: bag.inventory[0].aggregate_dwt,
                                        printing: false,
                                        saving: false,
                                    });
                                } else {
                                    let purity = bag.purity ? bag.purity : '';
                                    let purity_type = bag.purity_type ? bag.purity_type : '';
                                    this.QA.bags.push({
                                        bag_id: bag.id,
                                        bag_purity: bag.class + ' ' + purity + ' ' + purity_type,
                                        contains_melee: bag.contains_melee,
                                        bag_type_id: bag.bag_type_id,
                                        bag_type: bag.bagType.name,
                                        class: bag.class,
                                        purity: bag.purity,
                                        purity_type: bag.purity_type,
                                        material_dwt: bag.bagType.bag_dwt,
                                        items: bag.inventory.length,
                                        item_weight: bag.dwt,
                                        printing: false,
                                        saving: false,
                                        _showDetails: false,
                                    });
                                }
                            }
                            // Build array of inventory by metal type
                            bag.inventory.forEach((item) => {
                                if (!this.QA.inventoryByMetal[bag.class]) {
                                    this.$set(this.QA.inventoryByMetal, bag.class, []);
                                }
                                this.QA.inventoryByMetal[bag.class].push(item);
                            });
                        });

                        this.$forceUpdate();
                        this.$nextTick(() => {
                            this.loading_items = false;
                        });
                    });
                });

            this.$http.get('/orders/' + this.$route.params.id + '?include=packages')
                .then(response => {
                    this.order = response.data.data;
                    this.$store.commit('setActiveOrder', this.order);

                    if (this.order.packages) {
                        this.intakeItemWeight = 0;
                        this.order.packages.forEach((item) => {
                            this.intakeItemWeight += item.items_dwt;
                        });
                    }

                    // skip first change in data
                    this.$nextTick(() => {
                        this.loading = false;
                        this.working = false;
                    });
                })
                .catch((error) => {
                    if (error.response && error.response.status === 404) {
                        this.$router.replace({path: '/appraisals/not-found/' + this.$route.params.id});
                    }
                });
            /*FOR GETTING QA*

             */
        },

        printLabel(type, item) {
            if (type === 'bag') {
                let bag = _.find(this.bags, ['id', item.bag_id]);
                if (bag) {
                    bag.customer = this.order.customer;
                    bag.order = this.order;
                    item = bag;
                }
            } else {
                item.customer = this.order.customer;
                item.order = this.order;
            }
            this.$label(type, item);
        },

        changeBagSize(item) {
            console.log(item);
            item.saving = true;
            this.$http.put('/bags/' + item.bag_id, {
                bag_type_id: item.bag_type_id,
                class: item.class,
                purity: item.purity
            }).then((response) => {
                console.log(response);
                item.saving = false;
                this.getData();
            });
        },
        printLabelsAndCloseOverride() {
            let _this = this;
            this.$refs.GenericPopups.displayPermission =
                {
                    title: 'Inventory Weight Mismatch',
                    permission: 'manage inventory',
                    text: 'Expected item\'s weight from Intake was <span class="font-xl font-weight-bold">'+ this.intakeItemWeight +' dwt</span>. Total item\'s weight is currently <span class="font-xl font-weight-bold">'+ this._getWeightOfAllItems +' dwt</span>.',
                    ok: 'Manager Override', //manager override will do function
                    cancel: 'Cancel', //cancel is a 'ok'
                    okAction: function(){
                        _this.printLabelsAndClose();
                    },
                    endPointsLater: ['/orders/' + this.order.id]
                };
        },
        async printLabelsAndClose() {
            this.working = true;
            this.QA.bags.forEach((bag) => {
                this.printLabel('bag', bag);
            });
            if (this.print_hold_labels) {
                this.QA.holds.forEach((hold) => {
                    this.printLabel('hold', hold);
                });
            }
            this.printLabel('order', this.order);
            this.printLabel('order', this.order);
            // print additional order labels if total dwt exceeds 100 troy ounces
            if ((this._getWeightOfAllItems / 20) > 100) {
                this.printLabel('order', this.order);
                this.printLabel('order', this.order);
            }
            if(this.order.status_id <= 6) { //if its after inventory/inventory hold, its shouldn't set the status.
                this.$http.put('/orders/' + this.order.id, {status_id: 16}).then(() => {
                    this.working = false;
                    this.$store.commit('setActiveOrder', null);
                    this.$router.push({path: '/appraisals'});
                }).catch(error => {
                    alert(error.response.data.message);
                    this.working = false;
                });
            } else {
                this.$store.commit('setActiveOrder', null);
                this.$router.push({path: '/appraisals'});
            }
        },
    },
    computed: {
        // create bags with nested inventory items
        _getMeltItems() {
            let obj = {};
            let inventory = this.QA.inventoryByMetal;
            Object.keys(inventory).forEach(function (key) {
                inventory[key].forEach(function (item) {
                    if (item.status_name === 'melt') {
                        if (!(item.bag_id in obj)) {
                            obj[item.bag_id] = [];
                        }
                        obj[item.bag_id].push(item);
                    }
                });
            });
            return obj;
        },

        // Add weight and item totals of melt items by metal type
        _getMeltItemsSummary() {
            let that = this;
            let totals = {};
            Object.keys(this._getBagsByMetal).forEach(function (key) {
                let items = that._getBagsByMetal[key].reduce((acc, item) => acc + item.items, 0);
                let weight = that._getBagsByMetal[key].reduce((acc, item) => parseFloat(acc) + parseFloat(item.item_weight), 0);
                totals[key] = {
                    items: items,
                    weight: _.round(weight, 2),
                };
            });
            return totals;
        },

        // organize QA Melt bags by metal type
        _getBagsByMetal() {
            let bags = {};
            this.QA.bags.forEach(function (bag) {
                if (bag.class in bags) {
                    bags[bag.class].push(bag);
                } else {
                    bags[bag.class] = [];
                    bags[bag.class].push(bag);
                }
            });
            return bags;
        },

        _getTotalHeldItems() {
            let totalHeldItems = 0;
            this.QA.holds.forEach(function () {
                totalHeldItems++;
            });
            return totalHeldItems;
        },

        _getTotalItems() {
            let totalItems = 0;
            this.QA.bags.forEach(function (bag) {
                totalItems += bag.items;
            });

            return totalItems + this._getTotalHeldItems;
        },

        _getWeightOfHeldItems() {
            let totalHeldItemsWeight = 0;
            this.QA.holds.forEach(function (hold) {
                totalHeldItemsWeight += parseFloat(hold.dwt);
            });
            return _.round(totalHeldItemsWeight, 2);
        },

        _getWeightOfPreciousMetalItems() {
            let totalPreciousMetalItemsWeight = 0;
            this.QA.bags.forEach(function (bag) {
                if (bag.class !== 'other') {
                    totalPreciousMetalItemsWeight += parseFloat(bag.item_weight);
                }
            });
            return _.round(totalPreciousMetalItemsWeight, 2);
        },

        _getWeightOfNonPreciousMetalItems() {
            let totalNonPreciousMetalItemsWeight = 0;
            this.QA.bags.forEach(function (bag) {
                if (bag.class === 'other') {
                    totalNonPreciousMetalItemsWeight += parseFloat(bag.item_weight);
                }
            });
            return _.round(totalNonPreciousMetalItemsWeight, 2);
        },

        _getWeightOfAllItems() {
            return _.round(this._getWeightOfNonPreciousMetalItems + this._getWeightOfPreciousMetalItems + this._getWeightOfHeldItems, 2);
        },

        _getWeightWithBags() {
            let totalWeightWithBags = 0;
            this.QA.bags.forEach(function (bag) {
                totalWeightWithBags += parseFloat(bag.item_weight) + parseFloat(bag.material_dwt);
            });
            return _.round(totalWeightWithBags + this._getWeightOfHeldItems, 2);
        },

        _withinAllowedWeightVariance() {
            if (!this.loading_items) {
                return this.$refs.WeightValidation.validateBaggingWeight(this.intakeItemWeight, this.QA.inventoryByMetal);
                //return !((this.intakeItemWeight > this._getWeightOfAllItems + .1) || (this.intakeItemWeight < this._getWeightOfAllItems - .1));
            } else {
                return true;
            }

        },
    },

};
</script>

<style scoped>
.metal-header {
    background-color: rgba(26, 65, 93, 1);
    color: white;
}
</style>
